import { render, staticRenderFns } from "./XterminateInstance.vue?vue&type=template&id=4235c688&scoped=true&"
import script from "./XterminateInstance.vue?vue&type=script&lang=js&"
export * from "./XterminateInstance.vue?vue&type=script&lang=js&"
import style0 from "./XterminateInstance.vue?vue&type=style&index=0&id=4235c688&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4235c688",
  null
  
)

export default component.exports